import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown'

import classes from '../styles.module.scss'
import { toPathname } from '../utils'

interface NavDropdownItem {
  route: string
  text: string
}

interface NavDropdownProps {
  title: string
  items: NavDropdownItem[]
  pathname: string
}

export const NavDropdown: React.FC<NavDropdownProps> = ({ title, items, pathname }) => {
  return (
    <li className={classes.dropdown}>
      <span className={classes.dropdown__text}>
        {title}
        <FontAwesomeIcon size='sm' icon={faChevronDown} />
      </span>
      <ul className={classes.dropdown__list}>
        {items.map((item) => (
          <Link
            key={item.route}
            href={item.route}
            className={classNames({
              [classes.dropdown__item]: true,
              [classes.dropdown__item__active]: pathname === toPathname(item.route)
            })}
          >
            <li data-testid="desktop-item">
              {item.text}
              <div className={classes.item__underline} />
            </li>
          </Link>
        ))}
      </ul>
    </li>
  )
}
